export const SEARCH_INPUT_CHANGE = 'SEARCH_INPUT_CHANGE';
export const SEARCH_INPUT_SUBMIT = 'SEARCH_INPUT_SUBMIT';
export const SEARCH_AUTOSUGGEST_SUCCESS = 'SEARCH_AUTOSUGGEST_SUCCESS';
export const SEARCH_INPUT_BLUR = 'SEARCH_INPUT_BLUR';
export const SEARCH_INPUT_FOCUS = 'SEARCH_INPUT_FOCUS';



// WEBPACK FOOTER //
// ./src/search/types.js